import React from "react";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { CreateForm } from "./components/CreateForm";

export const OrganizationCreate: React.FC = () => {
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Mis clientes" : ""}
              defaultHref="/app/gerencia/mis-clientes"
              color="light"
            />
          </IonButtons>
          <IonTitle>Nuevo cliente</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Nuevo cliente</IonTitle>
          </IonToolbar>
        </IonHeader>
        <CreateForm />
      </IonContent>
    </IonPage>
  );
};
